module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/5-f5278a1d56431e0ffd1027b0d40f15c3.svg";